import React from 'react';
import { useParams } from 'react-router';

import LogsContainer from '../../components/Logs/LogsContainer.js';

const PatientLogs = () => {
  const { patientId } = useParams();

  return <LogsContainer patientId={patientId} />;
};

export default PatientLogs;
